
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./navbar/Logo";
import { DesktopNavigation } from "./navbar/DesktopNavigation";
import { MobileNavigation } from "./navbar/MobileNavigation";

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  
  const scrollToGallery = (e: React.MouseEvent) => {
    e.preventDefault();
    const gallerySection = document.getElementById('gallery');
    if (gallerySection) {
      gallerySection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  return (
    <nav className="bg-white shadow-md fixed w-full z-50" role="navigation" aria-label="Main navigation">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <Logo />
          <DesktopNavigation />

          <div className="md:hidden flex items-center">
            <button 
              onClick={toggleMenu} 
              className="text-secondary-dark hover:text-primary"
              aria-expanded={isOpen}
              aria-label="Toggle mobile menu"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        <MobileNavigation isOpen={isOpen} scrollToGallery={scrollToGallery} />
      </div>
    </nav>
  );
};
